import React, { useState } from "react";

// time zone library
import { useTimezoneSelect, allTimezones } from "react-timezone-select";

// component
import { Dropdown } from "@Vytelle/admin/src/components/Common/FormElements";

const labelStyle = "original";
function TimezoneInput({
  name,
  label,
  onChange,
  disabled,
  required,
  placeholder,
}) {
  const { options, parseTimezone } = useTimezoneSelect({
    labelStyle,
    allTimezones,
  });
  const timeZones = (options || [])?.map((obj) => {
    return {
      ...obj,
      value: obj?.value,
      name: `(GMT ${obj?.offset < 0 ? '' : '+'} ${obj?.offset || 0}) ${obj?.value}`
    };
  });

  const onTimeZoneChange = (timeZone) => {
    !!timeZone && parseTimezone(parseTimezone);
    !!onChange && onChange(timeZone);
  };

  return (
    <Dropdown
      name={name}
      label={label}
      placeholder={placeholder}
      options={timeZones}
      onChange={onTimeZoneChange}
      required={required}
      disabled={disabled}
    />
  );
}

export default TimezoneInput;
